<template>
  <div class="flex col align center">
    <navbar active='2'></navbar>
    <img src="@/assets/Jonathan Moser Resume 2019.png" />
    <div class="flex align center">
      <a href="https://www.linkedin.com/in/jonathanjmoser/" target="_blank"><i class="fab fa-linkedin"></i>linkedin.com/in/jonathanjmoser</a>
      <a href="./Jonathan Moser Resume 2019.pdf" target="_blank"><i class="fas fa-download"></i>Resume</a>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/Nav.vue'

export default {
  name: 'resume',
  components: {
    navbar: Navbar
  }
}
</script>

<style scoped>
.resume-container {
  justify-content: flex-start;
}
img{
  margin: 0px 0 40px;
  max-width: 66%;
  object-fit: contain;
  object-position: top;
}
a{
  font-size: .9em;
  color: #666;
  margin: 0 5vw 40px;
}
@media screen and (max-width: 1200px){
  img{
    margin: 4px;
    max-width: 95%;
  }
}
</style>
